/**
 * Copyright © Pronko Consulting Ltd. All rights reserved.
 */

import ClientGallery from "./modules/ClientGallery";
import PopupFormToggle from "./modules/PopupFormToggle";

const clientGallery = new ClientGallery();
clientGallery.animationMarquee();

document.addEventListener('DOMContentLoaded', e => {
    new PopupFormToggle(document.querySelectorAll('[data-popup]'));
});


document.addEventListener('DOMContentLoaded', function () {

  const overlay = document.createElement('div');
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.background = '#00000033';
  overlay.style.zIndex = '15';
  overlay.style.display = 'none';
  
  document.body.appendChild(overlay);

  const input = document.querySelector('.swp-input');

  if (input) {
    input.addEventListener('focus', () => {
      input.classList.add('is-expanded');
    });

    input.addEventListener('blur', () => {
      if (input.value.trim() === '') {
        input.classList.remove('is-expanded');
      }
    });
  }

  const bodyObserver = new MutationObserver(() => {
    const results = document.querySelector('.searchwp-live-search-results');
    if (!results) return;

    const isOpen = results.classList.contains('searchwp-live-search-results-showing');
    overlay.style.display = isOpen ? 'block' : 'none';
  });

  bodyObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });


  overlay.addEventListener('click', () => {
    const results = document.querySelector('.searchwp-live-search-results');
    if (results) {
      results.classList.remove('searchwp-live-search-results-showing');
    }
    
    if (input) {
      input.blur(); 
      if (input.value.trim() === '') {
        input.classList.remove('is-expanded');
      }
    }
  });

});
